import { TDiiaSignInStore } from './types';

export const diiaInitialState: TDiiaSignInStore = {
  deepLink: 'http://',
  dynamicLink: '',
  requestId: '',
  loading: false,
  error: null,
  status: '',
};
